var PageEditor = new JS.Class({
  initialize: function(editorContainer, isEmbeddedPage) {
    this.container = $(editorContainer);
    this.components = [];

    this.isEmbeddedPage = isEmbeddedPage;
    this.saveButtonText = $('.editor-save-button').val();

    if (this.isEmbeddedPage) {
      $('.editor-save-button').click(this.method('pageSaveClicked'));
      $('.editor-save-submit-button').click(
        this.method('pageSaveSubmitClicked')
      );
    } else {
      this.container
        .find('.editor-save-button')
        .click(this.method('pageSaveClicked'));
    }

    if ($('#pageLock').length > 0) {
      this.editLock = new UIEditLock('#pageLock', {});
    }
  },

  addComponent: function(component) {
    this.components.push(component);
    component.setEditor(this);
  },

  savePage: function(submit) {
    var data = {};

    data['submit'] = submit;
    data['commitMessage'] = this.container.find('#commitMessage').val();
    data['notifySubscribers'] = this.container
      .find('#notifySubscribers')
      .prop('checked');
    data['submissionGroup'] = this.container.find('#submissionGroup').val();
    var subscriberCount = this.container.find('#subscriberCount').text();

    if (data['notifySubscribers']) {
      if (
        !confirm(
          'Are you sure you want to notify ' + subscriberCount + ' subscribers'
        )
      ) {
        return;
      }
    }

    for (var i = 0, len = this.components.length; i < len; i++) {
      var chunk = this.components[i].getSaveData();
      if (chunk === false) {
        return; // bail out, component is thinking
      }
      data = $.extend(data, chunk);
    }
    return this.doSavePage(data, null, null, null);
  },

  saveComponent: function(component, init, success, error) {
    return this.doSavePage(component.getSaveData(), init, success, error);
  },

  doSavePage: function(componentData, init, success, error) {
    var that = this;
    if (init == null) {
      init = this.method('savePageInit');
    }

    if (success == null) {
      var postSaveCallback = $('.editor-save-button').data('onPostSave');
      success = function(e) {
        that.savePageSuccess.call(that, e, componentData);
        if (postSaveCallback) {
          postSaveCallback();
        }
      };
    }

    if (error == null) {
      error = this.method('savePageError');
    }

    var editorFormAction = $('#editor-form').attr('action');
    if (editorFormAction.indexOf('?') === 0) {
      editorFormAction = document.location.search;
    }

    var queryParams = this.getQueryParams();

    init.call();
    $.ajax(editorFormAction, {
      type: 'POST',
      data: {
        method: 'saveComponents',
        _new: queryParams._new,
        componentData: JSON.stringify(componentData),
      },
      success: success,
      error: error,
    });
  },

  savePageInit: function() {
    if (!this.isEmbeddedPage) {
      this.container.find('.editor-save-button').attr('disabled', 'disabled');
      this.container.find('.editor-save-button').val('Saving...');
    }
  },

  savePageSuccess: function(res, data) {
    $.each(this.components, function() {
      this.onSaveSuccess(res);
    });

    var that = this;

    if (!this.isEmbeddedPage) {
      this.container.find('.editor-save-button').removeAttr('disabled');
      this.container.find('.editor-save-button').val('Saved!');
      setTimeout(function() {
        that.container.find('.editor-save-button').val(that.saveButtonText);
      }, 3000);
    }

    var extraData;
    if (data.submit) {
      extraData = { submit: true };
    }

    $(window).trigger('savePageSuccess', extraData);

    if (window.self !== window.parent) {
      window.parent.postMessage(
        JSON.stringify(data),
        location.protocol + '//' + location.host
      );
    } else {
      if (!this.isEmbeddedPage) {
        location.href = location.pathname;
      }
    }
  },
  savePageError: function(error) {
    $.each(this.components, function() {
      this.onSaveError(error);
    });
    if (this.isEmbeddedPage) {
      $('.editor-save-button').removeAttr('disabled');
      $('.editor-save-watcher').val('Error.');
    } else {
      this.container.find('.editor-save-button').removeAttr('disabled');
      this.container.find('.editor-save-watcher').html('Error.');
    }
  },
  pageSaveClicked: function() {
    this.savePage();
  },
  pageSaveSubmitClicked: function() {
    this.savePage(true);
  },
  getQueryParams: function() {
    var queryParams = {};
    var queryStr = window.location.search;

    queryStr.replace(/\\?([^?=&]+)(=([^&#]*))?/g, function($0, $1, $2, $3) {
      if (typeof $3 === 'string') {
        queryParams[$1] = decodeURIComponent($3);
      }
    });

    return queryParams;
  },
});
